import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import useUiDesignActions from "../app/useUiDesignActions";

export default function UiDesignPreferenceToggle({ user, actions }) {
  const {
    pending,
    isEligible,
    onV2Lane,
    switchToV2,
    switchToLegacy,
  } = useUiDesignActions({ user, actions });

  if (!isEligible) {
    return null;
  }

  const checked = user?.uiDesignPreference === "v2" || onV2Lane;

  const handleChange = async (event) => {
    if (event.target.checked) {
      await switchToV2();
      return;
    }
    await switchToLegacy();
  };

  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.08)", mb: 3 }} />
      <Typography
        variant="h6"
        sx={{ mb: 1.5, fontWeight: 700, color: "rgba(255,255,255,0.9)" }}
      >
        Appearance
      </Typography>
      <Typography
        variant="body2"
        sx={{ mb: 2, color: "rgba(255,255,255,0.6)", lineHeight: 1.5 }}
      >
        Switch between the new Ouro lobby and navigation design and the classic
        layout. You can change this anytime.
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={handleChange}
            disabled={pending}
            name="newOuroDesignEnabled"
          />
        }
        label="New Ouro design"
      />
    </Box>
  );
}

UiDesignPreferenceToggle.propTypes = {
  user: PropTypes.object,
  actions: PropTypes.object,
};
